module.exports = "/static/assets/590e583abf28698083f3fd82f99f4fb7.png";